import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import { addSection } from 'rangeConfig/boaxel/behaviors/addSection';

export const sectionsProductListConfig: ProductListConfig = {
  cardsSubtitle:
    'communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
  infoButtonAriaLabel:
    'communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
  categories: [
    {
      id: 'section',
      categoryTitle: '',
      products: [{ path: 'type', value: ProductType.BOAXEL_UPRIGHT_SECTION }]
    }
  ],
  behaviors: {
    productClicked: [addSection],
    productDropped: [addSection]
  },
  productFilters: [],
  cluster: [],
  sortOrder: [{ path: 'communicatedDimensions.width', reverse: true }]
};
